import { monoValueStyles } from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.styles';

import { getConditionalObject } from 'utils/data';

export const partRowStyles = {
  display: 'flex',
  gap: '10px',
  padding: '10px 14px 10px 32px',
  borderTop: '1px solid',
  borderColor: ({ palette }) => palette.divider,
};

export const partKindStyles = {
  flexShrink: 0,
  width: '64px',
};

// Template text is prose: one line, cut short, since the row only has to identify the block.
const partTextNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getPartNameStyles = ({ isFieldName, isRemoved }) => ({
  ...(isFieldName ? monoValueStyles : partTextNameStyles),
  ...getConditionalObject(isRemoved, { textDecoration: 'line-through' }),
});
